export const NOW_DATE = new Date();
